import { SimpleFormValidationProp } from './validation/types';
import { ValueToStoreData, SimpleFormSerialize } from './types';
import { FIELD_TYPE } from './field-types';

export const ACTION = {
  VALUE_CHANGE: 'SIMPLE_FIELD:VALUE_CHANGE',
  LOAD_OPTIONS_CODES: 'SIMPLE_FIELD:REQUEST_CODETABLE',
  LOAD_OPTIONS_CODES_OK: 'SIMPLE_FIELD:RECEIVE_CODETABLE',
  LOAD_OPTIONS_CODES_FAIL: 'SIMPLE_FIELD:FAIL_CODETABLE',
  INSERT_VALUE_TO_STORE: 'SIMPLE_FIELD:INSERT_VALUE_TO_STORE',
  INSERT_COMPONENT_DATA_TO_STORE: 'SIMPLE_FIELD:INSERT_COMPONENT_DATA_TO_STORE',
  CLEAR_VALUE_IN_STORE: 'SIMPLE_FIELD:CLEAR_VALUE_IN_STORE',
  VALIDATION_CHANGE: 'SIMPLE_FIELD:VALIDATION_CHANGE',
  RESET_CHANGES_LISTENER: 'SIMPLE_FIELD:RESET_CHANGES_LISTENER',
  CLEAR_ALL_VALUES: 'SIMPLE_FIELD:CLEAR_ALL_VALUES',
  LOAD_CATEGORY_CODES: 'SIMPLE_FIELD:REQUEST_CODETABLE_CATEGORY',
  LOAD_CATEGORY_CODES_OK: 'SIMPLE_FIELD:RECEIVE_CODETABLE_CATEGORY',
  LOAD_CATEGORY_CODES_FAIL: 'SIMPLE_FIELD:FAIL_CODETABLE_CATEGORY_ERROR'
};

export class ValueChange {
  public type: string = ACTION.VALUE_CHANGE;
  constructor(public path: string | string[], public context: any, public value: any) { }
}

export class RequestCodetable {
  public type: string = ACTION.LOAD_OPTIONS_CODES;
  constructor(public path: string | string[], public context: string) { }
}

export class ReceiveCodetable {
  public type: string = ACTION.LOAD_OPTIONS_CODES_OK;
  constructor(public path: string | string[], public context: string, public condition: any, public data?: any, public value?: number) { }
}

export class FailCodetable {
  public type: string = ACTION.LOAD_OPTIONS_CODES_FAIL;
  constructor(public path: string | string[], public context: string) { }
}

export class RequestCodetableCategory {
  public type: string = ACTION.LOAD_CATEGORY_CODES;
  constructor(public path: string | string[], public context: string) { }
}

export class ReceiveCodetableCategory {
  public type: string = ACTION.LOAD_CATEGORY_CODES_OK;
  constructor(public path: string | string[], public context: string, public condition: any, public data?: any, public value?: number) { }
}

export class FailCodetableCategory {
  public type: string = ACTION.LOAD_CATEGORY_CODES_FAIL;
  constructor(public path: string | string[], public context: string) { }
}

export class InsertValueToStore {
  public type: string = ACTION.INSERT_VALUE_TO_STORE;
  constructor(public path: string | string[], public output: ValueToStoreData) { }
}

export class InsertComponentDataToStore {
  public type: string = ACTION.INSERT_COMPONENT_DATA_TO_STORE;
  constructor(public path: string | string[], public componentName: string, public componentType: FIELD_TYPE,
    public serialize: SimpleFormSerialize, public validationProps: SimpleFormValidationProp[]) { }
}

export class ClearValueInStore {
  public type: string = ACTION.CLEAR_VALUE_IN_STORE;
  constructor(public path: string | string[], public componentName: string) { }
}

export class ResetChangesListener {
  public type: string = ACTION.RESET_CHANGES_LISTENER;
  constructor(public path: string | string[]) { }
}
export class ClearAllValues {
  public type: string = ACTION.CLEAR_ALL_VALUES;
  constructor(public path: string | string[]) { }
}

export class ValidationChange {
  public type: string = ACTION.VALIDATION_CHANGE;
  constructor(public path: string | string[], public validation: any) { }
}
